function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import App from 'modules/App';
export const useFormValues = (organizationProposal)=>{
    const countries = useSelector(App.selectors.countries);
    const languages = useSelector(App.selectors.languages);
    const localizationResources = useSelector(App.selectors.localizationResources);
    const [formValues, setFormValues] = useState({
        values: {}
    });
    useEffect(()=>{
        const values = {
            values: _object_spread({}, organizationProposal)
        };
        const { countryCode, languageCode } = organizationProposal;
        const country = countries.find((c)=>c.alpha2Code === countryCode);
        values.values.country = get(localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName);
        const language = find(languages, (lang)=>lang.code === languageCode || lang.code === App.constants.APP_LOCALE_LANGUAGES_MAP[languageCode]);
        values.values.language = language.nativeName;
        setFormValues(values);
    }, [
        organizationProposal
    ]);
    return formValues;
};
